const translation = {
  // Hero Section
  heroTitle: 'اتصل بالإنترنت بسهولة وأمان',
  heroSubtitle: 'اختر باقتك المفضلة وادفع بطريقة آمنة عبر Orange Money أو Moov أو MTN أو Wave',
  securePayment: 'دفع آمن',
  instantActivation: 'تفعيل فوري',
  support247: 'دعم 24/7',

  // Package Selection
  chooseYourPackage: 'اختر باقتك المناسبة',
  packageDescription: 'باقات متنوعة تناسب جميع احتياجاتك من الإنترنت',
  
  basicPackage: 'الباقة الأساسية',
  oneHour: 'ساعة واحدة',
  basicFeature1: 'سرعة تصفح ممتازة',
  basicFeature2: 'مناسبة للاستخدام الخفيف',
  basicFeature3: 'دعم فني متاح',

  standardPackage: 'الباقة القياسية',
  sixHours: '6 ساعات',
  standardFeature1: 'سرعة عالية للتصفح',
  standardFeature2: 'مشاهدة الفيديوهات بجودة HD',
  standardFeature3: 'مناسبة للعمل والدراسة',
  standardFeature4: 'أولوية في الدعم الفني',

  premiumPackage: 'الباقة المميزة',
  oneDay: 'يوم كامل',
  premiumFeature1: 'سرعة فائقة للتصفح',
  premiumFeature2: 'مشاهدة الفيديوهات بجودة 4K',
  premiumFeature3: 'تحميل ورفع سريع',
  premiumFeature4: 'دعم فني مخصص',

  ultimatePackage: 'الباقة الشاملة',
  oneWeek: 'أسبوع كامل',
  ultimateFeature1: 'أقصى سرعة متاحة',
  ultimateFeature2: 'بث مباشر بدون انقطاع',
  ultimateFeature3: 'ألعاب أونلاين بدون تأخير',
  ultimateFeature4: 'دعم فني VIP على مدار الساعة',
  ultimateFeature5: 'أولوية قصوى في الشبكة',

  currency: 'فرنك',
  popular: 'الأكثر شعبية',
  selectPackage: 'اختر الباقة',
  selected: 'تم الاختيار',

  // Payment Methods
  choosePaymentMethod: 'اختر طريقة الدفع',
  paymentDescription: 'ادفع بأمان عبر طريقة الدفع المفضلة لديك',
  phoneNumber: 'رقم الهاتف',
  enterPhoneNumber: 'أدخل رقم هاتفك',
  payNow: 'ادفع الآن',
  secureTransaction: 'معاملة آمنة ومشفرة بالكامل',
  paymentSuccess: 'تم الدفع بنجاح!',
  paymentSuccessMessage: 'تم استلام دفعتك وجاري تفعيل باقتك',
  activationMessage: 'ستتلقى رسالة تأكيد خلال دقائق قليلة',

  // Features
  whyChooseUs: 'لماذا تختارنا؟',
  whyChooseUsDesc: 'نوفر لك أفضل تجربة إنترنت بأسعار تنافسية وخدمة متميزة',
  
  securePaymentTitle: 'دفع آمن ومشفر',
  securePaymentDesc: 'نستخدم أحدث تقنيات التشفير لحماية معلوماتك المالية وضمان أمان معاملاتك',
  
  instantActivationTitle: 'تفعيل فوري',
  instantActivationDesc: 'احصل على الإنترنت فوراً بعد إتمام الدفع دون أي انتظار أو تأخير',
  
  support247Title: 'دعم فني 24/7',
  support247Desc: 'فريق الدعم الفني متاح على مدار الساعة لمساعدتك في أي وقت',
  
  multiplePaymentTitle: 'طرق دفع متعددة',
  multiplePaymentDesc: 'ادفع بالطريقة التي تناسبك عبر Orange Money أو Moov أو MTN أو Wave',
  
  highSpeedTitle: 'سرعة عالية',
  highSpeedDesc: 'استمتع بسرعات إنترنت عالية تناسب جميع احتياجاتك من التصفح والبث والألعاب',
  
  easyAccessTitle: 'سهولة الوصول',
  easyAccessDesc: 'واجهة بسيطة وسهلة الاستخدام تمكنك من الاتصال بالإنترنت في ثوانٍ معدودة',

  // Footer
  footerDescription: 'منصة رائدة لتوفير خدمات الإنترنت في المناطق النائية بطرق دفع مرنة وآمنة',
  quickLinks: 'روابط سريعة',
  packages: 'الباقات',
  payment: 'الدفع',
  aboutUs: 'من نحن',
  contactUs: 'اتصل بنا',
  paymentMethods: 'طرق الدفع',
  contactInfo: 'معلومات الاتصال',
  address: 'باماكو، مالي',
  allRightsReserved: 'جميع الحقوق محفوظة',

  // New translations for enhanced sections
  getStarted: 'ابدأ الآن',
  aboutUs: 'من نحن',
  aboutTitle: 'نربط المجتمعات بالعالم الرقمي',
  aboutDesc: 'منصة رائدة في توفير خدمات الإنترنت للمناطق النائية مع حلول دفع مرنة وآمنة',
  happyCustomers: 'عملاء سعداء',
  cities: 'مدينة',
  uptime: 'وقت التشغيل',
  yearsExperience: 'سنوات خبرة',
  ourMission: 'مهمتنا',
  ourVision: 'رؤيتنا',
  ourValues: 'قيمنا',
  missionContent: 'نسعى لتوفير خدمات إنترنت عالية الجودة وبأسعار معقولة للمناطق النائية، مع التركيز على سهولة الوصول والدفع الآمن عبر وسائل متعددة تناسب جميع العملاء.',
  visionContent: 'أن نكون الخيار الأول لخدمات الإنترنت في المناطق النائية، ونساهم في تقليص الفجوة الرقمية من خلال توفير اتصال موثوق وسريع للجميع.',
  valuesContent: 'نؤمن بالشفافية، الجودة، والابتكار. نضع عملاءنا في المقام الأول ونعمل باستمرار على تحسين خدماتنا لتلبية احتياجاتهم المتطورة.',
  reliable: 'موثوق',
  secure: 'آمن',
  fast: 'سريع',
  affordable: 'بأسعار معقولة',
  ourPartners: 'شركاؤنا',
  partnersTitle: 'نعمل مع الأفضل',
  partnersDesc: 'شراكات استراتيجية مع أفضل مزودي خدمات الدفع والتكنولوجيا',
  orangeDesc: 'خدمة دفع موثوقة وسريعة',
  moovDesc: 'حلول دفع مرنة ومبتكرة',
  mtnDesc: 'دفع إلكتروني آمن ومضمون',
  waveDesc: 'تحويلات فورية بدون رسوم',
  mikrotikDesc: 'حلول شبكات احترافية',
  mikhmonDesc: 'إدارة متقدمة للشبكات',
  learnMore: 'اعرف المزيد',
  customerReviews: 'آراء عملائنا',
  reviewsDesc: 'اكتشف تجارب عملائنا الراضين',
  customer1Name: 'أحمد محمد',
  customer1Role: 'مستخدم منذ سنتين',
  customer1Comment: 'خدمة ممتازة وسريعة، الدفع سهل جداً عبر Orange Money. أنصح الجميع بهذه المنصة!',
  customer2Name: 'فاطمة علي',
  customer2Role: 'عميلة جديدة',
  customer2Comment: 'أخيراً وجدت خدمة إنترنت موثوقة في منطقتنا. الأسعار معقولة والدعم الفني رائع.',
  customer3Name: 'عمر حسن',
  customer3Role: 'مستخدم منذ 6 أشهر',
  customer3Comment: 'السرعة ممتازة والتفعيل فوري. تجربة رائعة من البداية للنهاية.',
  satisfaction: 'رضا العملاء',
  support: 'دعم فني',
  reliability: 'موثوقية',

  // About Section Modal
  aboutUsDetails: 'تفاصيل عن الشركة',
  ourStory: 'قصتنا',
  ourStoryText: 'بدأت رحلتنا من رؤية بسيطة: توفير خدمات إنترنت موثوقة وبأسعار معقولة للمناطق النائية. منذ تأسيسنا، نجحنا في خدمة أكثر من 50,000 عميل في أكثر من 15 مدينة، وأصبحنا الخيار الأول للعائلات والشركات التي تبحث عن اتصال إنترنت سريع وآمن.',
  ourMission: 'مهمتنا',
  missionText: 'نسعى لتوفير خدمات إنترنت عالية الجودة بأسعار تنافسية، مع التركيز على تجربة العميل والابتكار المستمر في حلول الاتصال.',
  ourVision: 'رؤيتنا',
  visionText: 'أن نكون الشركة الرائدة في توفير خدمات الإنترنت في المناطق النائية، ونساهم في تقليص الفجوة الرقمية من خلال حلول مبتكرة وموثوقة.',
  ourValues: 'قيمنا',
  integrity: 'النزاهة والشفافية',
  integrityText: 'نلتزم بأعلى معايير الأمانة والشفافية في جميع تعاملاتنا مع عملائنا وشركائنا.',
  innovation: 'الابتكار المستمر',
  innovationText: 'نستثمر في أحدث التقنيات لتقديم أفضل الحلول وأكثرها كفاءة لعملائنا.',
  customerFirst: 'العميل أولاً',
  customerFirstText: 'رضا عملائنا هو أولويتنا القصوى، ونعمل على تقديم دعم متميز على مدار الساعة.',
  ourTeam: 'فريقنا',
  ourTeamText: 'يتكون فريقنا من خبراء متخصصين في مجال الاتصالات وتكنولوجيا المعلومات، يعملون بشغف لتقديم أفضل الخدمات وحل أي مشكلة قد تواجه عملاءنا.',
  close: 'إغلاق',

  // Captive Portal
  captivePortalTitle: 'بوابة الدخول للشبكة',
  selectYourPackage: 'اختر الباقة المناسبة لك',
  enterPhoneForOTP: 'أدخل رقم هاتفك للحصول على رمز التحقق',
  verifyOTP: 'تحقق من رمز OTP',
  completePayment: 'أتمم عملية الدفع',
  yourCredentials: 'بيانات الدخول الخاصة بك',
  
  // Admin Dashboard
  adminDashboard: 'لوحة التحكم الإدارية',
  overview: 'نظرة عامة',
  transactions: 'المعاملات',
  users: 'المستخدمين',
  commercialNetworks: 'الشبكات التجارية',
  reports: 'التقارير والتحليلات',
  totalRevenue: 'إجمالي الإيرادات',
  activeUsers: 'المستخدمين النشطين',
  todayTransactions: 'معاملات اليوم',
  networkManagement: 'إدارة الشبكات',
};

export default translation;
